import { render } from "./InputSelect.vue?vue&type=template&id=59545311&scoped=true&ts=true"
import script from "./InputSelect.vue?vue&type=script&lang=ts"
export * from "./InputSelect.vue?vue&type=script&lang=ts"

import "./InputSelect.vue?vue&type=style&index=0&id=59545311&scoped=true&lang=css"
import "./InputSelect.vue?vue&type=style&index=1&id=59545311&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59545311"]])

export default __exports__